const searchFieldWidth = () => {
    const headerIdentic = document.querySelector('.Header__identic');
    const headerHamburger = document.querySelector('.Header__hamburger');
    let headerGap = 12;
    if (!document.querySelector('.Page')) return false;
    if (document.querySelector('.Page').offsetWidth > 743) {
        headerGap = 18;
    }

    const searchField = document.querySelector('.Search-field');

    if (headerIdentic && headerHamburger && headerGap && searchField) {
        const searchFieldWidthValue = headerIdentic.offsetWidth
            + headerHamburger.offsetWidth
            + headerGap * 2;
        searchField.style.width = `${searchFieldWidthValue}px`;
    }
};

export default searchFieldWidth;
